/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PurchaseOrderMonitoringResource } from './';
import {
    PurchaseOrderMonitoringResourceFromJSON,
    PurchaseOrderMonitoringResourceFromJSONTyped,
    PurchaseOrderMonitoringResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface PurchaseOrderMonitoringSearchResultResource
 */
export interface PurchaseOrderMonitoringSearchResultResource {
    /**
     * 
     * @type {Array<PurchaseOrderMonitoringResource>}
     * @memberof PurchaseOrderMonitoringSearchResultResource
     */
    results: Array<PurchaseOrderMonitoringResource>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOrderMonitoringSearchResultResource
     */
    totalElements: number;
}

/**
 * Check if a given object implements the PurchaseOrderMonitoringSearchResultResource interface.
 */
export function instanceOfPurchaseOrderMonitoringSearchResultResource(value: object): value is PurchaseOrderMonitoringSearchResultResource {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    return true;
}

export function PurchaseOrderMonitoringSearchResultResourceFromJSON(json: any): PurchaseOrderMonitoringSearchResultResource {
    return PurchaseOrderMonitoringSearchResultResourceFromJSONTyped(json, false);
}

export function PurchaseOrderMonitoringSearchResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseOrderMonitoringSearchResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(PurchaseOrderMonitoringResourceFromJSON)),
        'totalElements': json['totalElements'],
    };
}

export function PurchaseOrderMonitoringSearchResultResourceToJSON(value?: PurchaseOrderMonitoringSearchResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map((v) => PurchaseOrderMonitoringResourceToJSON(v))),
        'totalElements': value['totalElements'],
    };
}

